import React, { useState } from "react";
import Iframe from "react-iframe";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";
import { useCustomFrame } from "hooks/api";
import { API } from "api";
import { Box, CircularProgress, FormControlLabel, Switch, Typography } from "@material-ui/core";
import { LoaderContainer } from "components/LoadingOverlay/LoadingOverlay.styled";
import { useTranslation } from "react-i18next";
import { getLocalStorageIsDoNotShowWelcomeTab, setLocalStorageDoNotShowWelcomeTab } from "utils";

export const WelcomeTab = () => {
    const { t } = useTranslation();
    const { selectedMaterialSpecId, selectedMaterialId } = useMaterialSpecs();
    const { data, isFetching } = useCustomFrame("welcome", selectedMaterialSpecId || 0, selectedMaterialId || 0, false);
    const [isDoNotShowOn, setIsDoNotShowOn] = useState<boolean>(getLocalStorageIsDoNotShowWelcomeTab());

    return (
        <Box display="flex" flexDirection="column" height="100%" width="100%">
            {isFetching ? (
                <LoaderContainer>
                    <CircularProgress />
                </LoaderContainer>
            ) : (
                <>
                    <Iframe
                        frameBorder={0}
                        url={`${API.serverUrl}${data?.url}`}
                        width="100%"
                        height="100%"
                        position="relative"
                    />
                    <Box width="100%" mt={1}>
                        <FormControlLabel
                            label={
                                <Typography variant="subtitle2" color="textSecondary">
                                    <Box fontWeight="fontWeightBold">{t("campaign.info.doNotShowWelcomeScreen")}</Box>
                                </Typography>
                            }
                            control={
                                <Switch
                                    color="primary"
                                    checked={isDoNotShowOn}
                                    onChange={(event, checked) => {
                                        setIsDoNotShowOn(checked);
                                        setLocalStorageDoNotShowWelcomeTab(checked);
                                    }}
                                />
                            }
                        />
                    </Box>
                </>
            )}
        </Box>
    );
};
